import { Outlet } from "react-router-dom";
import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Link, useLocation } from "react-router-dom";
import {
  FileText,
  BarChart3,
  TrendingUp,
  Plus
} from "lucide-react";
import { cn } from "@/lib/utils";

export default function BudgetsLayout() {
  const location = useLocation();

  const tabs = [
    {
      value: "",
      label: "Orçamentos",
      icon: FileText,
      path: "/services/budgets"
    },
    {
      value: "analytics",
      label: "Análises",
      icon: BarChart3,
      path: "/services/budgets/analytics"
    },
    {
      value: "reports",
      label: "Relatórios",
      icon: TrendingUp,
      path: "/services/budgets/reports"
    },
    {
      value: "conversion",
      label: "Conversão",
      icon: TrendingUp,
      path: "/services/budgets/conversion"
    }
  ];

  const getCurrentTab = () => {
    const path = location.pathname;
    if (path === "/services/budgets") return "";
    if (path.includes("/analytics")) return "analytics";
    if (path.includes("/reports")) return "reports";
    if (path.includes("/conversion")) return "conversion";
    return "";
  };

  return (
    <MainLayout>
      <SEO
        title="Orçamentos de Serviços"
        description="Gerencie orçamentos, análises e relatórios de conversão"
        keywords="orçamentos, serviços, conversão, relatórios"
      />

      <div className="section-delimited">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold">Orçamentos de Serviços</h1>
            <p className="text-muted-foreground">
              Gerencie orçamentos, acompanhe conversões e gere relatórios detalhados
            </p>
          </div>

          <Link
            to="/services/budgets/new"
            className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            <Plus className="h-4 w-4" />
            Novo Orçamento
          </Link>
        </div>

        <Tabs value={getCurrentTab()} className="space-y-4">
          <TabsList className="grid w-full grid-cols-4">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <TabsTrigger
                  key={tab.value}
                  value={tab.value}
                  className={cn(
                    "flex items-center gap-2",
                    getCurrentTab() === tab.value && "data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                  )}
                  asChild
                >
                  <Link to={tab.path}>
                    <Icon className="h-4 w-4" />
                    {tab.label}
                  </Link>
                </TabsTrigger>
              );
            })}
          </TabsList>

          <TabsContent value={getCurrentTab()} className="space-y-4">
            <Outlet />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}